// api
import { fetchApi } from '@/api'
// actions
const papeleriaProductsCategoriesAll = (context) => {
  let url = 'inventory/products/indexpapeleria'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_CATEGORIES_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsCategoriesForm = (context) => {
  
  let url = 'inventory/products/createPapeleriacategories'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_CATEGORIES_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsCategoriesShow = (context, payload) => {
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'inventory/products/categories/' + obj.id + '/edit'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_CATEGORIES_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsCategoriesCreate = (context, payload) => {
  let url = 'inventory/products/categories/storePapeleria'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_CATEGORIES_CREATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsCategoriesUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/categories/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_CATEGORIES_UPDATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsCategoriesDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/categories/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_CATEGORIES_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  papeleriaProductsCategoriesAll,
  papeleriaProductsCategoriesForm,
  papeleriaProductsCategoriesShow,
  papeleriaProductsCategoriesCreate,
  papeleriaProductsCategoriesUpdate,
  papeleriaProductsCategoriesDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/products/categories/actions.js